import { useQuery } from '@apollo/client';
import { getMultipleSchema } from '../application/query';
function useGetEntitySchemasAsObj(identifiers, shouldSkip = false) {
  const uniqueIdentifiers = [...new Set(identifiers)].filter(Boolean);
  const skip = shouldSkip || uniqueIdentifiers.length < 1;
  // placeholder required so query isn't empty but will be skipped
  const queryIdentifiers = skip ? ['placeholder'] : uniqueIdentifiers;
  return useQuery(getMultipleSchema(queryIdentifiers), {
    skip
  });
}
export default useGetEntitySchemasAsObj;
//# sourceMappingURL=use-get-entity-schemas-as-obj.js.map